import { createFileRoute } from '@tanstack/react-router'
import { PolicyPackReviewPage } from '@/features/policy-pack/review-page'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'

// Final-review fix wave / Important 1: the review page is a write-oriented
// surface (Approve/Reject as draft policy). Mirror the API write gate's
// legacyRoles exactly — see policy-pack/index.tsx for the full rationale.
const POLICY_PACK_MANAGE_ROLES = ['owner', 'admin', 'team_leader'] as const

export const Route = createFileRoute('/_authenticated/_organization/compliance/policy-pack/$runId')({
  beforeLoad: async () => { await requireRoles([...POLICY_PACK_MANAGE_ROLES]); await requireActiveSubscription() },
  component: PolicyPackReviewPage,
})
